import { ProcedureReportTranslations } from '../models/procedure-report-translaction-model';

export const enUS: ProcedureReportTranslations = {
  title: 'Procedure Report',
  tabs: {
    procedures: 'Procedures',
    reports: 'My Reports',
  },
  reports: { layoutName: 'Procedure Report' },
  fields: {
    carrier: 'Carrier',
    procedureCode: 'Procedure Code',
    procedureDescription: 'Procedure Description',
    tussCode: 'TUSS Code',
    event: 'Event',
    group: 'Group',
    subGroup: 'Subgroup',
    preventive: 'Preventive',
    preventiveClassification: 'Preventive Classification',
    complement: 'Complement',
    predictive: 'Predictive',
    predictiveClassification: 'Predictive Classification',
    editedBy: 'Edited by',
    editedAt: 'Edited at',
    status: 'Status',
    additionalTussCode: 'Additional TUSS Code',
    updateDescription: 'Update Description',
    active: 'Active',
    ruleLevel: 'Level',
    ruleValue: 'Value',
    ruleCriteria: 'Criteria',
    ruleReason: 'Reason',
  },
  filter: {
    expandSearch: 'Expand Search Options',
    collapseSearch: 'Collapse Search Options',
    clear: 'Clear Filters',
    placeholders: { select: 'Select' },
    status: {
      classified: 'Classified',
      unclassified: 'Unclassified',
      pendingApproval: 'Pending approval',
    },
  },
  actions: {
    export: 'Export',
    addNewRegister: 'Add new register',
    massActions: {
      label: 'Mass Actions',
      editValues: 'Edit Values',
      approve: 'Approve',
    },
    rowActions: {
      updateHistory: 'Update history',
      discardNewRegister: 'Discard new register',
      approve: 'Approve',
      justification: 'Edit rule',
      editRule: 'Edit rule',
    },
  },
  table: {
    noData: 'No records found for the selected filters.',
    headers: {
      carrier: 'Carrier',
      procedureCode: 'Procedure Code',
      procedureDescription: 'Procedure Description',
      tussCode: 'TUSS Code',
      event: 'Event',
      complement: 'Complement',
      group: 'Group',
      subGroup: 'Subgroup',
      predictive: 'Predictive',
      predictiveClassification: 'Predictive Class.',
    },
  },
  messages: {
    exportError: 'Error exporting procedure report',
    loadingText: 'Loading...',
    noResultText: 'No results found.',
    saveError: 'Error saving procedure report row',
    searchError: 'Error fetching procedure report',
    classificationError: 'Error fetching classification indicators',
    saveSuccess: 'Record saved successfully.',
    createSuccess: 'Record created successfully.',
    createManySuccess: '{count} records created successfully.',
    createPartialSuccess: '{created} of {total} records created. Not created: {rejected}',
    createNoneCreated: 'No records were created. Not created: {rejected}',
    rejectedCarrier: '{carrier} - {reason}',
    noPermission: 'You do not have permission to save this record.',
    historyError: 'Error fetching procedure report change history',
    approveSuccess: '{approved} procedure(s) approved. {ignored} ignored.',
    approveError: 'Error approving procedure classification.',
    correctRuleSuccess: 'Rule corrected successfully.',
    correctRuleError: 'Error correcting classification rule.',
    validationFields: {
      carrierId: 'The "Carrier" field is required.',
      carrierIds: 'Select at least one carrier.',
      procedureCodeId: 'The "Procedure Code" field is required.',
      procedureDescriptionId: 'The "Procedure Description" field is required.',
      tussCodeId: 'The "TUSS Code" field is required.',
      eventId: 'The "Event" field is required.',
      complementId: 'The "Complement" field is required.',
      groupId: 'The "Group" field is required.',
      subGroupId: 'The "Subgroup" field is required.',
      predictiveId: 'The "Predictive" field is required.',
      predictiveClassificationId: 'The "Predictive Classification" field is required.',
    },
    errors: {
      dimComplementNotFound: 'Complement not found.',
      descriptionAlreadyExists: 'The description already exists.',
      dimEventNotFound: 'Event not found.',
      dimGroupNotFound: 'Group not found.',
      dimPredictiveNotFound: 'Predictive not found.',
      dimPredictiveClassificationNotFound: 'Predictive Classification not found.',
      dimSubgroupNotFound: 'Subgroup not found.',
      predictiveIdsNotFound: 'One or more predictive IDs not found.',
      groupIdsNotFound: 'One or more group IDs not found.',
      dimProcedureNotFound: 'Procedure not found.',
      dimProcedureNotFoundWithId: 'Procedure not found with id: {id}',
      procedureAlreadyExists: 'Procedure with code {code} and carrierId {id} already exists.',
      procedureCodeNotNull: 'ProcedureCode: must not be null.',
      carrierIdNotNull: 'CarrierId: must not be null.',
      rejectedProcedureAlreadyExists: 'a record with this procedure code already exists.',
      rejectedCarrierNotFound: 'carrier not found.',
    },
  },
  dashboard: {
    classifiedDescription: 'Classified procedures',
    nonClassifiedDescription: 'Non classified procedures',
    pendingApprovalDescription: 'Pending approval',
  },
  levels: {
    event: 'Event',
    complement: 'Complement',
    group: 'Group',
    subgroup: 'Subgroup',
    predictive: 'Predictive',
    predictiveClassification: 'Predictive classification',
  },
  modals: {
    bulkTitle: 'Edit Values ​​in Bulk',
    editProcedureCode: 'Edit Procedure Code',
    editProcedureDescription: 'Edit Procedure Description',
    editTussCode: 'Edit TUSS Code',
    justificationTitle: 'Edit rule',
    editRuleTitle: 'Edit rule',
  },
};
